<template>
<!--top nav-->
  <nav class = "navbar navbar-expand-md sticky-top navbar-light bg-light text-black-50 ">
    <div class = "container-fluid px-3">
      <!--      <a class="navbar-brand" href="#">Navbar</a>-->
      <button class = "navbar-toggler" type = "button" data-bs-toggle = "collapse" data-bs-target = "#navbarSupportedContent" aria-controls = "navbarSupportedContent" aria-expanded = "false" aria-label = "Toggle navigation">
        <span class = "navbar-toggler-icon"></span>
      </button>
      <div class = "collapse navbar-collapse" id = "navbarSupportedContent">
        <ul class = "navbar-nav me-auto mb-2 mb-lg-0">
          <li class = "nav-item">
            <router-link to="/" class = "nav-link active" aria-current = "page">خانه<span class = "fas fa-home ps-2"></span></router-link>
          </li>
          <li class = "nav-item">
            <router-link :to="{name: 'courses'}" class = "nav-link" href = "#">دوره ها<span class = "fas fa-book ps-2"></span></router-link>
          </li>
          <!--          <li class = "nav-item">-->
          <!--            <a class = "nav-link" href = "#about">درباره ما<span class = "fas fa-question ps-2"></span></a>-->
          <!--          </li>-->
          <li class = "nav-item">
            <a class = "nav-link" href = "tel:09032313681"> تماس <span class = "fas fa-phone-volume ps-2"></span></a>
          </li>
          <li class = "nav-item">
            <router-link to="/employ" class = "nav-link" href = "">استخدام<span class = "fas fa-briefcase ps-2"></span></router-link>
          </li>
        </ul>
        <ul class = "navbar-nav ms-auto mb-2 mb-lg-0 float-md-end" >

          <li class = "nav-item dropdown" >
            <a  class = "nav-link dropdown-toggle" href = "#" id = "navbarDropdown1" role = "button" data-bs-toggle = "dropdown" aria-expanded = "false">
              ورود<span class = "fas fa-key px-2"></span></a>
            <ul class = "dropdown-menu mx-auto" aria-labelledby = "navbarDropdown1" style="width:250px ;justify-content: center">
              <li style="width: 250px;"  class="mx-auto" >
                <form class = "form1 pt-3 row mx-auto justify-content-center" >
                  <div class = "form-group col-12 p-2">
                    <input type = "email" class = "form-control form-control-sm mb-1" id = "un" placeholder = "ایمیل" name = "email">
                    <input type = "password" class = "form-control form-control-sm mb-1" id = "pw" placeholder = "رمزعبور" name = "pswd">

                    <!--     <div class="custom-control custom-checkbox mb-3 text-center">-->
                    <!--     <input type="checkbox" class="custom-control-input" id="customCheck" name="example1" checked >-->
                    <!--     <label class="custom-control-label" for="customCheck">مرا بخاطر بسپار</label>-->
                    <!--     </div>-->
                    <button type = "submit" class = "btn btn-sm btn-block mb-2 btn-success ">
                      ورود<span class = "fas fa-key px-2"></span></button>
                    <a class = "mr-2" style = "font-size: 12px;" href = "">فراموشی رمز</a>
                  </div>
                </form>


              </li>
            </ul>
          </li>
          <!--          <li class = "nav-item dropdown">-->
          <!--            <a class = "nav-link dropdown-toggle" href = "#" id = "navbarDropdown" role = "button" data-bs-toggle = "dropdown" aria-expanded = "false">-->
          <!--              ورود-->
          <!--            </a>-->
          <!--            <ul class = "dropdown-menu" aria-labelledby = "navbarDropdown">-->
          <!--              <li><a class = "dropdown-item" href = "#">Action</a></li>-->
          <!--              <li><a class = "dropdown-item" href = "#">Another action</a></li>-->
          <!--              <li>-->
          <!--                <hr class = "dropdown-divider">-->
          <!--              </li>-->
          <!--              <li><a class = "dropdown-item" href = "#">Something else here</a></li>-->
          <!--            </ul>-->
          <!--          </li>-->

          <li class = "nav-item">
            <router-link to="/register" class = "nav-link" href = "#">ثبت نام<span class = "fas fa-user-edit ps-2"></span></router-link>
          </li>
          <li class = "nav-item dropdown">
            <a class = "nav-link dropdown-toggle" href = "#" id = "navbarDropdown" role = "button" data-bs-toggle = "dropdown" aria-expanded = "false">
              رکسانا رحیمی<span class = "fas fa-user px-2"></span></a>
            <ul class = "dropdown-menu" aria-labelledby = "navbarDropdown">
              <li><router-link to="/profile" class = "dropdown-item" >پروفایل</router-link></li>
              <!--              <li><a class = "dropdown-item" href = "#">دوره ها</a></li>-->
              <li>
                <hr class = "dropdown-divider">
              </li>
              <li><a class = "dropdown-item" href = "#">خروج</a></li>
            </ul>
          </li>

        </ul>
      </div>
    </div>
  </nav>
<!--top nav-->
</template>

<script>
export default {
  name: "TheMenu",
  mounted(){
    if(window.innerWidth<767){
      document.querySelectorAll('.nav-item:not(.dropdown), .dropdown-item').forEach((element)=>{
        element.addEventListener('click',()=>{
          document.querySelector('.navbar-toggler').click();
        })
      })
    }

  }
}
</script>

<style scoped>

</style>